module.exports = __webpack_public_path__ + "media/svg/received-5ccb9277.svg";